import React from "react";
import {
  View,
  Text,
  Dimensions,
  Platform,
} from "react-native";
import { network_error } from "../utils/images";
import { Button } from "../components/core/Button";
import { Color, globalFontStyle } from "../assets";
import RNRestart from "react-native-restart";
import FastImage from "../common/FastImage";
import { globalImport } from "../common/globalImports";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError = (error) => {
    return { hasError: true };
  };
  componentDidCatch = (error, info) => {
    if (!globalImport?.isWeb) {
      globalImport?.sentry?.captureException(error);
    }
  };

  refreshPage = () => {
    if (globalImport.isWeb) {
      window.location.replace("/");
    } else {
      RNRestart.restart();
    }
  };
  render() {
    const { hasError } = this.state;
    const { children } = this.props;
    return hasError ? (
      <View
        style={{
          flex: 1,
        }}
      >
        <View
          style={{ justifyContent: "center", alignItems: "center", flex: 1 }}
        >
          <FastImage
            style={{ height: 200, width: 200, marginBottom: 10 }}
            source={network_error()}
          />
          <Text style={[globalFontStyle.appFontTitle, { color: Color.blue1 }]}>
            It's not you. It's us!
          </Text>
          <View style={{ marginTop: 10 }}>
            <Button
              variant="primary"
              onPress={this.refreshPage}
              style={{
                flex: globalImport.isWeb ? {} : 0,
                paddingHorizontal: 20,
              }}
            >
              Try Again
            </Button>
          </View>
        </View>
      </View>
    ) : (
      children
    );
  }
}
